import React, { useState, useEffect } from 'react';
import Calendar from './Calendar';
import moment, { Moment } from 'moment';
import { createWeekDate, getTimeRange } from './utils';

import style from './index.module.scss';
import { useScheduleContext } from 'page/MeetingSchedule/Provider/ScheduleProvider';
import eventBus from 'page/MeetingSchedule/utils/event';

interface IProps {
  taskList?: number[];
  noticeList?: number[];
  onSwitch?: (startTime: number, endTime: number) => void;
  onSelectDate?: (date: number) => void;
}

const getDateList = (date: Moment) => {
  return createWeekDate(date).map((d) => d);
};

const getToday = () => moment().startOf('day');

const CalendarBar: React.FC<IProps> = (props) => {
  const { taskList, noticeList, onSwitch, onSelectDate } = props;

  const { originState } = useScheduleContext();
  const { currentTime, isScheduleDateSelected } = originState;
  const today = getToday();
  const [date, setDate] = useState<Moment>(() => moment(currentTime));
  const [selectDate, setSelectDate] = useState<number | undefined>(isScheduleDateSelected ? currentTime : undefined);

  const handleCalendarChange = (date: Moment, dateList: Moment[]) => {
    setDate(date);
    eventBus.emit('onDataChange', date);
    onSwitch && onSwitch(...getTimeRange(dateList[0], dateList[dateList.length - 1]));
  };

  const handleCalendarSelect = (date: Moment) => {
    setDate(date);
    eventBus.emit('onDataChange', date);
    eventBus.emit('onSelectChange', date);
    onSelectDate && onSelectDate(date.valueOf());
  };

  useEffect(() => {
    console.log(currentTime, '更新');
    setDate(moment(currentTime));
    setSelectDate(isScheduleDateSelected ? currentTime : undefined);
  }, [currentTime, isScheduleDateSelected]);

  // 初始执行一次
  useEffect(() => {
    const tempdateList = getDateList(moment(currentTime));
    onSwitch && onSwitch(...getTimeRange(tempdateList[0], tempdateList[tempdateList.length - 1]));
  }, []);

  return (
    <div className={style.warp}>
      <Calendar
        date={date}
        today={today}
        selectDate={selectDate}
        taskList={taskList}
        noticeList={noticeList}
        onChange={handleCalendarChange}
        onSelect={handleCalendarSelect}
      />
    </div>
  );
};

export default CalendarBar;
